import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

export const ProfilePictureStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      backgroundColor: "rgba(182, 142, 147, 0.92)",
      boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
      borderRadius: "50%",
      height: "90px",
      width: "90px",
      position: "relative",
      bottom: "10px",
      right: "10px",
    },
    picture: {
      borderRadius: "50%",
      height: "70px",
      width: "70px",
      backgroundColor: "#FFFFFF",
    },
  }),
);
